import { memo } from "react";
import { OverflowTooltip } from "@4uhub/lib4uhub";
import { ITicketChannel } from "../EvaluationLogs/model";

interface ITicketChannelProps {
  data?: ITicketChannel;
}

const TicketChannel: React.FC<ITicketChannelProps> = ({ data }) => {
  if (!data) return <>-</>;

  return (
    <OverflowTooltip
      text={data.name}
      tooltip={data.name}
      variant="body2"
      textTransform="none"
    />
  );
};

export default memo(TicketChannel);
